export const getGlobalSearchShortcutLabel = () => {
  if (typeof navigator !== 'undefined' && navigator.platform.toLowerCase().includes('mac')) {
    return 'Cmd K';
  }

  return 'Ctrl K';
};
